<edgvr-front-feature-header></edgvr-front-feature-header>
<router-outlet></router-outlet>
